export default __webpack_public_path__ + "static/media/tonmoy-informal-black.d63b724f.png";